<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: 0 },
  description: { type: String, default: '' },
  icon: { type: String, default: 'i-lucide-activity' },
  tone: {
    type: String,
    default: 'blue',
    validator: value =>
      ['blue', 'amber', 'ruby', 'teal', 'slate'].includes(value),
  },
  clickable: { type: Boolean, default: true },
});

defineEmits(['click']);

const toneClasses = {
  blue: 'text-n-blue-11 outline-n-blue-6',
  amber: 'text-n-amber-11 outline-n-amber-6',
  ruby: 'text-n-ruby-11 outline-n-ruby-6',
  teal: 'text-n-teal-11 outline-n-teal-6',
  slate: 'text-n-slate-11 outline-n-weak',
};

const toneIconClasses = {
  blue: 'bg-n-blue-3 text-n-blue-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
  slate: 'bg-n-alpha-2 text-n-slate-11',
};
</script>

<template>
  <button
    type="button"
    class="flex flex-col gap-4 p-5 text-left transition-all rounded-xl outline outline-1 bg-n-solid-2 hover:bg-n-alpha-1 hover:shadow-sm focus-visible:outline-2 focus-visible:outline-n-brand"
    :class="[
      toneClasses[tone],
      clickable ? 'cursor-pointer' : 'cursor-default',
    ]"
    :disabled="!clickable"
    :aria-label="label"
    @click="$emit('click')"
  >
    <span class="flex items-center justify-between gap-3">
      <span class="text-sm font-medium text-n-slate-11">{{ label }}</span>
      <span
        class="grid size-9 shrink-0 place-items-center rounded-lg"
        :class="toneIconClasses[tone]"
      >
        <Icon :icon="icon" class="size-5" />
      </span>
    </span>
    <span class="text-4xl font-semibold text-n-slate-12">{{ value }}</span>
    <span v-if="description" class="text-xs text-n-slate-10">
      {{ description }}
    </span>
  </button>
</template>
